module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAHCAYAAAA8sqwkAAAACXBIWXMAAAsSAAALEgHS3X78AAAAgklEQVQYlW3NQQ2EMBBA0Q8GFgk4YB0sDkACpzkjZa+d00pAAhLAARJAQcmQhpRuJ+mhmffbwjk3AHZGEVnIjKpWwA/YSqAGPsCsqu+UBzwDnVkLvsAKvNIowk0wQ+G9TxcH0Nr3CW5FZL+CzGsWWfDA5u4gE9k88F8QRVO49jEGOAFqqj6vhrngywAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/survey/icon_dropdown.png
// module id = O4oP
// module chunks = 1